import * as designBuilderApi from '../api/designBuilder';
import updateSignature from './share/updateSignature';

export default () => (dispatch) => {
  designBuilderApi.getDCSignature().then((response) => {
    const signature = response.data;
    dispatch(updateSignature(signature));
  }).catch(() => {
    dispatch(updateSignature({ name: '', email: '', phone: '' }));
  });
};
